import { Users, GraduationCap, Settings, PenLine, MessageCircle, ArrowRight } from "lucide-react";

const services = [
  { icon: Users, title: "Patient Experience\nConsulting", desc: "Designing seamless journeys that build trust and loyalty." },
  { icon: Settings, title: "Operations\nImprovement", desc: "Streamlining workflows and processes for efficiency and growth." },
  { icon: GraduationCap, title: "Staff Coaching\n& Training", desc: "Empowering teams with communication, hospitality and service excellence." },
  { icon: PenLine, title: "Branding &\nDigital Design", desc: "Creating distinct identities that position clinics for lasting success." },
  { icon: MessageCircle, title: "Content & Social\nMedia Management", desc: "Strategic content that builds reputation and connects with the right audience." },
];

export default function WhatWeDo() {
  return (
    <section id="services" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        {/* Left intro */}
        <div className="lg:col-span-4">
          <div className="flex items-center gap-4 mb-8">
            <span className="text-[11px] tracking-[0.3em] tinde-gold uppercase">What We Do</span>
            <span className="w-10 h-px tinde-gold-bg"></span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl leading-[1.15] text-[#1a1a1a] mb-8">
            Comprehensive Solutions. Measurable Impact.
          </h2>
          <p className="text-[#5a5a5a] leading-relaxed mb-12 max-w-sm">
            Helping healthcare providers elevate patient experience, optimize operations, and build strong, trusted brands.
          </p>
          <a href="#services-list" className="group inline-flex items-center gap-4 text-[11px] tracking-[0.3em] uppercase text-[#1a1a1a] border-b border-[#1a1a1a] pb-2">
            Explore Services
            <ArrowRight size={14} className="hover-arrow tinde-gold" />
          </a>
        </div>

        {/* Right service grid */}
        <div id="services-list" className="lg:col-span-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-y-12 gap-x-10 scroll-mt-32">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} className="service-card group">
                <div className="service-icon-wrap w-12 h-12 flex items-center justify-center rounded-full mb-6">
                  <Icon size={22} className="tinde-gold" strokeWidth={1.3} />
                </div>
                <h3 className="text-[13px] tracking-[0.18em] uppercase text-[#1a1a1a] font-medium mb-4 whitespace-pre-line">
                  {s.title}
                </h3>
                <p className="text-sm text-[#5a5a5a] leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
